import { render } from "./TodoListCard.vue?vue&type=template&id=7dbd473a&scoped=true"
import script from "./TodoListCard.vue?vue&type=script&lang=js"
export * from "./TodoListCard.vue?vue&type=script&lang=js"

import "./TodoListCard.vue?vue&type=style&index=0&id=7dbd473a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dbd473a"]])

export default __exports__